import { FC } from "react";
import { HeaderNavigation } from "../HeaderNavigation/HeaderNavigation";
import { useAppSelector } from "../../toolkit/hooks";
import { Logo } from "./Logo/Logo";
import ProfilePopup from "components/ProfilePopup/ProfilePopup";
import styles from "./Header.module.sass";

export const Header: FC = () => {
	// const dispatch = useAppDispatch();

	const { authed } = useAppSelector((state) => state.profile);

	// const logoutHandler = () => {
	// 	localStorage.removeItem("token");
	// 	dispatch(logout());
	// };

	return (
		<header data-comment-false={true} className={styles.header}>
			<Logo />
			<HeaderNavigation authed={authed} />
			<ProfilePopup />
		</header>
	);
};
